<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.year(v-if='!loading')
      .grid
        .col-3_xs-12.titles
          router-link(:to={path: '/exhibitions'})
            h1.h-l
              | exhibitions
          h4.status
            | {{ $route.params.year }}
        .col-9_xs-12(v-if="exhibitions.length > 0")
          .grid.no-margin
            .col-6_xs-12(v-for="exhibition in exhibitions")
              router-link(:to="{path: year + '/' + exhibition.uid}")
                .screen-small(v-if="hero(exhibition)")
                  img.cover(:src="hero(exhibition)" :alt="altText(exhibition)")
                  .captions
                    h2.title.h-l.italic
                      | {{ exhibition.content.title }}
                    h2.dates.h-sm
                      | {{ date(exhibition) }}
                .screen-small(v-if="!hero(exhibition)")
                  img.cover(src="/static/images/sun.jpg" :alt="altText(exhibition)")
                  .noimagecaptions
                    h2.title.h-l.italic
                      | {{ exhibition.content.title }}
                    h2.dates.h-sm
                      | {{ date(exhibition) }}
        .col-9_xs-12(v-else)
          h2.standin
            | Full exhibitions list coming soon ...
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'

export default {
  name: 'exhibitions-year',
  mixins: [DataMixin, ComponentMixin],

  created () {
    this.key = 'exhibitions/' + this.year
    this.requestData(this.key, 'children')
  },

  methods: {
    // hero: function (image, files) {

    //   return files.find(item => item.filename === image)
    // },

    hero: function (exhibition) {
      if (exhibition.hero_cropped_sq !== '') {
        return exhibition.hero_cropped_sq.url
      } else if (exhibition.main_image !== '') {
        return exhibition.main_image.url
      } else {
        return false
      }
    },

    altText: function (exhibition) {
      return exhibition.title
    },

    startDate: function (exhibition) {
      return exhibition.content.start_date
    },

    endDate: function (exhibition) {
      return exhibition.content.end_date
    },

    startYear: function (exhibition) {
      return exhibition.content.start_year
    },

    endYear: function (exhibition) {
      return exhibition.content.end_year
    },

    date: function (exhibition) {
      const endDate = this.endDate(exhibition) + ', ' + this.endYear(exhibition)
      let startDate = startDate = this.startDate(exhibition)
      if (this.endYear(exhibition) !== this.startYear(exhibition)) {
        startDate = this.startDate(exhibition) + ', ' + this.startYear(exhibition)
      }
      return startDate + ' - ' + endDate
    }
  },

  computed: {
    exhibitions: function () {
      const exhibitions = this.loadedData[this.key]
      const mapped = exhibitions.map((e) => {
        const start = new Date(`${e.content.start_date} ${this.year}`)
        const end = new Date(`${e.content.end_date} ${this.year}`)
        e.timestampStart = start
        e.timestampEnd = end
        return e
      })
      const sorted = mapped.sort((a, b) => {
        return b.timestampStart - a.timestampStart !== 0 ? b.timestampStart - a.timestampStart : b.timestampEnd - a.timestampEnd
      })
      return sorted
    },

    year: function () {
      return this.$route.params.year
    },

    content: function () {
      return this.exhibition.content
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/_variables.sass'
  .content
    &.year
      .titles
        h2, h4
          padding-left: 0
      .status
        color: $exhibitions
    .standin
      margin-top: $paddingTop
</style>



// WEBPACK FOOTER //
// ExhibitionsYear.vue?3519a565